// extracted by mini-css-extract-plugin
export var grid = "style-module--grid--249e1";
export var grid__column = "style-module--grid__column--356d8";